import classNames from 'classnames';
import useStyles from 'isomorphic-style-loader/useStyles';
import { CircleAlert, CircleCheck } from 'lucide-react';
import { Label } from 'semantic-ui-react';

import s from './impact-status-label.scss';

export interface ImpactStatusLabelProps {
  /**
   * Whether any application version in the deployment is affected.
   */
  impacted: boolean;
}

/**
 * A pill indicating whether the current deployment is affected by the
 * vulnerability: a red IMPACTED badge or a green NOT IMPACTED badge.
 */
export const ImpactStatusLabel = ({ impacted }: ImpactStatusLabelProps) => {
  useStyles(s);

  const Icon = impacted ? CircleAlert : CircleCheck;

  return (
    <Label
      className={classNames(s.root, impacted ? s.impacted : s.notImpacted)}
      as="span"
    >
      <Icon aria-hidden className={s.icon} />
      {impacted ? 'IMPACTED' : 'NOT IMPACTED'}
    </Label>
  );
};

export default ImpactStatusLabel;
